<ng-container>
    <span>{{ date }}</span>
</ng-container>